import { observer } from "mobx-react";
import { CustomForm } from "../../customform/CustomForm";
import CustomDatePicker from "../../customform/fields/DateTime/CustomDatePicker";
import CustomSelect from "../../customform/fields/Select/CustomSelect";
import FormRow from "../../customform/layout/FormRow";
import { useStoreContext } from "../../..";
import { useEffect } from "react";
import { FieldTypeId } from "../../../lib/enums";
import {
  Treatment,
  TreatmentSaveRequest,
  TreatmentSaveRequestSchema,
} from "../../../models/Treatments";
import {
  convertToTreatmentPostRequest,
  convertToTreatmentPutRequest,
} from "../../../utils/helpers";
import React from "react";

const AntibioticEntryForm = observer(
  ({
    selectedDay,
    onDeSelect,
  }: {
    selectedDay: Treatment | undefined;
    onDeSelect: () => void;
  }) => {
    const { drugStore, indicationStore, treatmentStore } = useStoreContext();
    const [treatmentId, setTreatmentId] = React.useState<number | undefined>(
      undefined
    );
    useEffect(() => {
      if (!drugStore.drugs) {
        drugStore.getDrugs();
      }
    }, [drugStore.drugs]);

    useEffect(() => {
      setTreatmentId(selectedDay?.treatmentId);
    }, [selectedDay]);

    useEffect(() => {
      if (!indicationStore.indications) {
        indicationStore.getIndications();
      }
    }, [indicationStore.indications]);

    const saveEntry = (data: any) => {
      treatmentStore.saveTreatment(
        convertToTreatmentPostRequest(data as TreatmentSaveRequest)
      );
    };

    const updateEntry = (data: any) => {
      if (treatmentId) {
        treatmentStore.updateTreatment(
          treatmentId,
          convertToTreatmentPutRequest(data as TreatmentSaveRequest)
        );
        onDeSelect();
      }
    };

    return (
      <CustomForm
        zodDataSchema={TreatmentSaveRequestSchema}
        currentData={selectedDay as any}
        hideDeleteAndEditButtons
        hideReadOnlyChip
        hideSaveButton
        onSave={saveEntry}
        onUpdate={updateEntry}
        onDeSelect={onDeSelect}
      >
        <FormRow gapAfter>
          <CustomDatePicker
            nonForm
            fieldId={0}
            required
            alias="startDate"
            header="Startdatum"
            validations={[
              {
                isBefore: "endDate",
              },
            ]}
            typeId={FieldTypeId.DATE}
          />
        </FormRow>
        <FormRow gapAfter>
          <CustomDatePicker
            nonForm
            fieldId={0}
            alias="endDate"
            header="Slutdatum"
            typeId={FieldTypeId.DATE}
          />
        </FormRow>
        <FormRow gapAfter>
          <CustomSelect
            nonForm
            fieldId={0}
            required
            alias="drugId"
            header="Substansnamn"
            fieldOptions={
              drugStore.drugs?.map((a, index) => ({
                ...a,
                id: `${a.id}-${index}`,
              })) as any
            }
            labelProp="name"
            valueProp="id"
            typeId={FieldTypeId.DROPLIST}
            validations={[{ isNonNegative: "drugId" }]}
          />
        </FormRow>
        <FormRow gapAfter>
          <CustomSelect
            nonForm
            fieldId={0}
            required
            alias="indicationId"
            header="Indikation"
            fieldOptions={indicationStore.indications as any}
            labelProp="name"
            valueProp="id"
            typeId={FieldTypeId.DROPLIST}
            validations={[{ isNonNegative: "indicationId" }]}
          />
        </FormRow>
      </CustomForm>
    );
  }
);

export default AntibioticEntryForm;
